import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const clientAccountApi = createApi({
  reducerPath: "clientAccount",
  refetchOnFocus: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    updatePassword: build.mutation({
      query: passwordUpdate => ({
        url: '/api/ClientAccount/UpdatePassword/',
        method: 'POST',
        body: passwordUpdate
      })
    }),
    getCurrentClientAccount: build.query({
      query: () => '/api/ClientAccount/Current',
      providesTags: ['CurrentClientAccount']
    }),
    requestPasswordReset: build.mutation({
      query: passwordResetRequest => ({
        url: '/api/ClientAccount/RequestPasswordReset/',
        method: 'POST',
        body: passwordResetRequest
      })
    }),
    resetPassword: build.mutation({
      query: passwordReset => ({
        url: '/api/ClientAccount/ResetPassword/',
        method: 'POST',
        body: passwordReset
      })
    }),
    logInClientAccount: build.mutation({
      query: credentials => ({
        url: '/api/ClientAccount/LogIn',
        method: 'POST',
        body: credentials
      }),
      invalidatesTags: ['CurrentClientAccount']
    }),
    logOutClientAccount: build.mutation({
      query: () => ({
        url: '/api/ClientAccount/LogOut',
        method: 'POST'
      }),
      invalidatesTags: ['CurrentClientAccount']
    })
  }),
  tagTypes: ['CurrentClientAccount']
})

export const { useUpdatePasswordMutation, useGetCurrentClientAccountQuery, useRequestPasswordResetMutation, useResetPasswordMutation, useLogInClientAccountMutation, useLogOutClientAccountMutation } = clientAccountApi
